/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  role_arn: Yup.string().max(
    128,
    i18n.t('MAX_LENGTH_KEY', {
      value: 128,
    })
  ),
  owner_id: Yup.string().max(
    12,
    i18n.t('MAX_LENGTH_KEY', {
      value: 12,
    })
  ),
  external_id: Yup.string().max(
    40,
    i18n.t('MAX_LENGTH_KEY', {
      value: 40,
    })
  ),
  compartment_id: Yup.string().max(
    100,
    i18n.t('MAX_LENGTH_KEY', {
      value: 100,
    })
  ),
});
